// Переводы англоязычных enum-значений из API в русские подписи для UI.

const CALL_DIRECTION_LABELS = {
  incoming: 'Входящий',
  inbound: 'Входящий',
  outgoing: 'Исходящий',
  outbound: 'Исходящий',
  internal: 'Внутренний'
};

export const formatCallDirection = (value) => {
  if (!value) return '—';
  return CALL_DIRECTION_LABELS[String(value).trim().toLowerCase()] ?? value;
};

const NEGATIVE_SEVERITY_LABELS = {
  no: 'Нет',
  none: 'Нет',
  mild: 'Умеренный',
  hard: 'Жёсткий'
};

export const formatNegativeSeverity = (value) => {
  if (!value) return '';
  return NEGATIVE_SEVERITY_LABELS[String(value).trim().toLowerCase()] ?? value;
};

// Статусы заказов iiko (приходят в исходном виде из API доставки).
const ORDER_STATUS_LABELS = {
  unconfirmed: 'Не подтверждён',
  waitcooking: 'Ожидает приготовления',
  readyforcooking: 'Готов к приготовлению',
  cookingstarted: 'Готовится',
  cookingcompleted: 'Приготовлен',
  waiting: 'Ожидает',
  onway: 'В пути',
  delivered: 'Доставлен',
  closed: 'Закрыт',
  cancelled: 'Отменён'
};

export const formatOrderStatus = (value) => {
  if (!value) return '';
  return ORDER_STATUS_LABELS[String(value).trim().toLowerCase()] ?? value;
};
